import Axios from 'axios'

export default {
    getBasicEndpoint(endpoint){
        return Axios.get(endpoint).then(response => {
            return response.data
        })
    },

    getPostTitleAndDescription(id){
        return Axios.get('title-descrip', {
            params: {
                id: id
            }
        }).then(response => {
            return response.data
        })
    },

    getClinicalTrials(keyword = '', cancer_type = '', therapy_line = [], location_id = [], latitude = '', longitude = '', trial_status = '', county = [], radius = 20){
        return Axios.get('clinical-trials',{
            params: {
                keyword: keyword,
                cancer_type: cancer_type,
                therapy_line: therapy_line.length ? therapy_line.join(',') : null,
                location_id: location_id.length ? location_id.join(',') : null,
                latitude: latitude,
                longitude: longitude,
                trial_status: trial_status,
                county: county.length ? county.join(',') : null,
                radius: radius
            }
        }).then(response => {
            return response.data
        })
    },

    getEvents(keyword = '', start_date = '', end_date = ''){
        return Axios.get('events', {
            params: {
                keyword: keyword,
                start_date: start_date,
                end_date: end_date
            }
        }).then(response => {
            return response.data
        })
    },

    getNews(blog = '', news = '', start_date = '', end_date = '', physician = [], location = []){
        return Axios.get('news-articles', {
            params: {
                news: news,
                blog: blog,
                start_date: start_date,
                end_date: end_date,
                physician: physician.length ? physician.join(',') : null,
                location: location.length ? location.join(',') : null
            }
        }).then(response => {
            return response.data
        })
    },
}